import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const SOCIALS = [
  {
    name: 'Instagram',
    handle: '@astro_vasturemedies',
    href: 'https://www.instagram.com/astro_vasturemedies',
    icon: Instagram,
    testid: 'home-social-instagram',
  },
  {
    name: 'Facebook',
    handle: 'Astro Vastu Remedies',
    href: 'https://www.facebook.com/AstroVastuRemedies',
    icon: Facebook,
    testid: 'home-social-facebook',
  },
];

export const FollowUs = () => {
  return (
    <section className="py-14 lg:py-20 bg-gradient-to-b from-cream to-cream-dark" data-testid="home-follow-us">
      <div className="container mx-auto px-4 lg:px-8 text-center">
        <p className="text-gold font-medium tracking-wide uppercase text-sm mb-3">Join Our Community</p>
        <h2 className="font-serif text-lg md:text-lg font-bold text-foreground mb-2">
          Follow Us for Daily Remedies & Offers
        </h2>
        <p className="text-muted-foreground text-sm max-w-xl mx-auto mb-8">
          Get daily astrology tips, gemstone guidance and exclusive discounts on our social channels.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          {SOCIALS.map(({ name, handle, href, icon: Icon, testid }) => (
            <a
              key={name}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={testid}
              className="group flex items-center gap-3 bg-white rounded-full pl-3 pr-6 py-2.5 shadow-sm hover:shadow-lg border border-amber-100 transition-all duration-300 hover:-translate-y-0.5"
            >
              <span className="w-10 h-10 rounded-full gold-gradient flex items-center justify-center text-white group-hover:scale-105 transition-transform">
                <Icon className="w-5 h-5" />
              </span>
              <span className="text-left">
                <span className="block text-xs text-muted-foreground">{name}</span>
                <span className="block text-sm font-semibold text-foreground">{handle}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
